import styled from 'styled-components';
import { navyDeep, graySlate, neutralWhite } from '../../../themes/colors';
import { Accordion } from '../../../accordion';

export const EmployeeDetailsCardAccordion = styled(Accordion)`
    h3 {
        font-size: 16px;
        font-weight: 500;
        color: ${navyDeep};
        font-family: "Red Hat Display", sans-serif;
        margin: 0;
    }
`;

export const ImageWrapper = styled.div`
	width: 56px;
	height: 56px;
	overflow: hidden;
	border-radius: 4px;
`;

export const NameLabel = styled.span`
	font-size: 20px;
	font-weight: 600;
	color: ${navyDeep};
    font-family: "Red Hat Display", sans-serif;
`;

export const RoleLabel = styled.span`
	font-size: 14px;
	font-weight: 400;
	color: ${graySlate};
    font-family: "Red Hat Display", sans-serif;
`;

export const DetailsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const EmployeeDetailsWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const EmployeeDetailsCardWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
`;

export const EmployeeDetailsCardContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
    background-color: ${neutralWhite};
    border-radius: 4px;
    padding: 12px;
    box-shadow: 0 2px 5px 0 rgba(32, 56, 87, 0.08);
`;
